/* eslint-disable css-modules/no-unused-class, react/static-property-placement, react/no-unused-state,
jsx-a11y/mouse-events-have-key-events, react/button-has-type, react/static-property-placement,
react/prop-types, camelcase, react/no-deprecated, react/no-deprecated, react/sort-comp, react/jsx-curly-newline */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { DateRangePicker } from 'react-dates';
import { defineMessages, intlShape } from 'react-intl';
import {
  START_DATE,
  END_DATE,
  VERTICAL_ORIENTATION,
} from 'react-dates/constants';
import { connect } from 'react-redux';
import cx from 'classnames';
import moment from 'moment';

import history from '../../history';
import Button from '../../components/Button';
import TextBox from '../../components/TextBox';
import HotelType from '../../data/types/HotelType';
import { addFlashMessage, TYPE_ERROR } from '../../actions/flashMessage';

import s from './BookingEngine.css';
import iconCalendar from './icon-calendar.webp';
import iconCalendarAdd2x from './icon-calendar@2x.webp';

const dateFormatDefault = 'D MMM YYYY';
const dateFormatJa = 'YYYY/MM/DD';
const maximumNights = 30;
const minimumDate = moment().subtract(1, 'd');
const maximumDate = minimumDate
  .clone()
  .add(10, 'months')
  .endOf('month');

const messages = defineMessages({
  checkin: {
    id: 'hotel.bookingEngine.checkIn',
    defaultMessage: '##Check in##',
    description: 'Placeholder text for check in textbox on room-select engine',
  },
  checkout: {
    id: 'hotel.bookingEngine.checkOut',
    defaultMessage: '##Check out##',
    description: 'Placeholder text for check out textbox on room-select engine',
  },
  continue: {
    id: 'hotel.bookingEngine.continue',
    defaultMessage: '##Continue##',
    description: 'Label continue button',
  },
  pleaseSelectStayDates: {
    id: 'hotel.bookingEngine.pleaseSelectStayDates',
    defaultMessage: '##Please select stay dates##',
    description:
      'Error message when user click continue without selecting check in / check out',
  },
});

const maxMobileWidth = 992;

class BookingEngine extends React.Component {
  static propTypes = {
    hotel: HotelType.shape().isRequired,
    addFlashMessage: PropTypes.func.isRequired,
    onDateChange: PropTypes.func.isRequired,
    query: PropTypes.shape({
      check_in: PropTypes.string,
      check_out: PropTypes.string,
      rooms: PropTypes.string,
      adults: PropTypes.string,
      children: PropTypes.string,
      code: PropTypes.string,
    }),
  };

  static contextTypes = {
    intl: intlShape,
  };

  static defaultProps = {
    query: {
      check_in: moment().format('YYYY-MM-DD'),
      check_out: moment()
        .add(1, 'd')
        .format('YYYY-MM-DD'),
      rooms: 1,
      adults: 2,
      children: 0,
      code: '',
    },
  };

  constructor(props) {
    super(props);
    const {
      hotel: { check_in, check_out, rooms },
    } = props;
    let checkIn = moment();
    let checkOut = checkIn.clone().add(1, 'd');
    if(check_in && check_out) { // eslint-disable-line
      checkIn = moment(check_in);
      checkOut = moment(check_out);
    }
    this.state = {
      focusedInput: null,
      showingCalendar: false,
      isMobileDevice: false,
      isSoldOut: !rooms || rooms.length === 0,
      checkIn,
      checkOut,
    };
  }

  componentDidMount() {
    if (process.env.BROWSER) {
      this.onWindowResize();
    }
  }

  componentDidMount() {
    this.bindOnWindowResize = this.onWindowResize.bind(this);
    window.addEventListener('resize', this.bindOnWindowResize);
    this.addDateinputBorder();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      hotel: { check_in, check_out, rooms },
    } = nextProps;
    let checkIn = moment();
    let checkOut = checkIn.clone().add(1, 'd');
    if(check_in && check_out) { // eslint-disable-line
      checkIn = moment(check_in);
      checkOut = moment(check_out);
    }
    this.setState({
      isSoldOut: rooms.length === 0,
      checkIn,
      checkOut,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.bindOnWindowResize);
  }

  onWindowResize = () => {
    const isMobileDevice = window.innerWidth < maxMobileWidth;
    if (!isMobileDevice && !this.state.isMobileDevice) {
      setTimeout(() => {
        this.addDateinputBorder();
      }, 100);
    }
    this.setState({
      isMobileDevice,
    });
  };

  onSelectingStayDate = focusedInput => {
    this.setState({
      focusedInput,
      showingCalendar: focusedInput !== null,
    });
  };

  onDateChange = ({ startDate, endDate }) => {
    if (startDate !== null && endDate !== null) {
      this.props.onDateChange(startDate, endDate);
    }
    this.setState({
      checkIn: startDate,
      checkOut: endDate,
    });
  };

  onClickBookButton = () => {
    let {
      query: { rooms, adults, children },
    } = this.props;
    const {
      query: { code },
    } = this.props;
    if (typeof rooms === 'undefined') {
      rooms = 1;
    }
    if (typeof adults === 'undefined') {
      adults = 2;
    }
    if (typeof children === 'undefined') {
      children = 0;
    }
    const { checkIn, checkOut } = this.state;
    if (checkIn !== null && checkOut !== null) {
      const { hotel } = this.props;
      let search = `&rooms=${rooms}&adults=${adults}&children=${children}`;
      if (code) {
        search += `&code=${code}`;
      }
      history.push({
        pathname: `/${this.context.intl.locale}/booking/room-select/`,
        search: `hotel=${hotel.id}&check_in=${checkIn.format(
          'YYYY-MM-DD',
        )}&check_out=${checkOut.format('YYYY-MM-DD')}${search}`,
      });
    } else {
      this.props.addFlashMessage(
        this.context.intl.formatMessage(messages.pleaseSelectStayDates),
        TYPE_ERROR,
      );
    }
  };

  addDateinputBorder = () => {
    const docs = document.getElementsByClassName('DateInput');
    for (let i = 0; i < docs.length; i += 1) {
      docs[i].style.border = '1px solid #cacaca';
    }
  };

  bindOnWindowResize = null;

  render() {
    let dateFormat = dateFormatDefault;
    const { currentLocale } = this.props;
    if (currentLocale === 'ja') {
      dateFormat = dateFormatJa;
    }

    const {
      checkIn,
      checkOut,
      focusedInput,
      isMobileDevice,
      isSoldOut,
    } = this.state;
    let isOutsideRange;
    if (checkIn) {
      isOutsideRange = day =>
        focusedInput === END_DATE &&
        (day.isBefore(checkIn) ||
          day.isSameOrAfter(checkIn.clone().add(maximumNights, 'days')));
    }
    return (
      <div className={cx(s.root, s[this.context.intl.locale])}>
        <div className={s.desktop}>
          <div className={s.container}>
            <div className={s.background} />
            <div className={s.row}>
              <div className={s.body}>
                <div
                  className={cx(
                    s.datePickers,
                    (!checkIn || !checkOut) && s.noValue,
                  )}
                >
                  <DateRangePicker
                    isOutsideRange={isOutsideRange}
                    displayFormat={dateFormat}
                    readOnly
                    hideKeyboardShortcutsPanel
                    showDefaultInputIcon
                    customInputIcon={
                      <img
                        src={iconCalendar}
                        srcSet={`${iconCalendarAdd2x} 2x`}
                        alt="icon"
                      />
                    }
                    startDatePlaceholderText={this.context.intl.formatMessage(
                      messages.checkin,
                    )}
                    endDatePlaceholderText={this.context.intl.formatMessage(
                      messages.checkout,
                    )}
                    startDate={checkIn} // momentPropTypes.momentObj or null,
                    endDate={checkOut} // momentPropTypes.momentObj or null,
                    onDatesChange={this.onDateChange} // PropTypes.func.isRequired,
                    focusedInput={!isMobileDevice ? focusedInput : null} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={this.onSelectingStayDate}
                    isDayBlocked={day =>
                      day.isBefore(minimumDate) || day.isAfter(maximumDate)
                    }
                  />
                </div>
                <Button
                  className={s.bookButton}
                  label={this.context.intl.formatMessage(messages.continue)}
                  onClick={this.onClickBookButton}
                  disabled={isSoldOut}
                />
                <div className={s.edge} />
              </div>
            </div>
          </div>
        </div>
        <div className={s.mobile}>
          <div className={s.container}>
            <div className={s.row}>
              <div className={s.col6}>
                <TextBox
                  icon={{
                    normal: iconCalendar,
                    add2x: iconCalendarAdd2x,
                  }}
                  onClick={() => {
                    this.setState({
                      checkIn: null,
                      checkOut: null,
                      focusedInput: START_DATE,
                    });
                  }}
                  value={checkIn ? checkIn.format(dateFormat) : ''}
                  placeholder={this.context.intl.formatMessage(
                    messages.checkin,
                  )}
                  showFloatingLabel={false}
                  className={s.textBox}
                />
              </div>
              <div className={s.col6}>
                <TextBox
                  icon={{
                    normal: iconCalendar,
                    add2x: iconCalendarAdd2x,
                  }}
                  onClick={() => {
                    this.setState({
                      checkIn: null,
                      checkOut: null,
                      focusedInput: END_DATE,
                    });
                  }}
                  value={checkOut ? checkOut.format(dateFormat) : ''}
                  placeholder={this.context.intl.formatMessage(
                    messages.checkout,
                  )}
                  showFloatingLabel={false}
                  className={s.textBox}
                />
              </div>
            </div>
            <div className={s.row}>
              <div className={s.btnContainer}>
                <Button
                  className={cx(s.bookButton)}
                  label={this.context.intl.formatMessage(messages.continue)}
                  onClick={this.onClickBookButton}
                  disabled={isSoldOut}
                />
              </div>
            </div>
          </div>
          <div className={s.fullScreenDatePicker}>
            <DateRangePicker
              isOutsideRange={isOutsideRange}
              orientation={VERTICAL_ORIENTATION}
              displayFormat={dateFormat}
              readOnly
              showDefaultInputIcon
              customInputIcon={
                <img
                  src={iconCalendar}
                  srcSet={`${iconCalendarAdd2x} 2x`}
                  alt="icon"
                />
              }
              startDatePlaceholderText={this.context.intl.formatMessage(
                messages.checkin,
              )}
              endDatePlaceholderText={this.context.intl.formatMessage(
                messages.checkout,
              )}
              startDate={checkIn} // momentPropTypes.momentObj or null,
              endDate={checkOut} // momentPropTypes.momentObj or null,
              onDatesChange={this.onDateChange} // PropTypes.func.isRequired,
              focusedInput={isMobileDevice ? focusedInput : null} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
              onFocusChange={this.onSelectingStayDate}
              withFullScreenPortal
              isDayBlocked={day =>
                day.isBefore(minimumDate) || day.isAfter(maximumDate)
              }
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatch = { addFlashMessage };
const mapState = state => ({
  currentLocale: state.intl.locale,
});
export default connect(mapState, mapDispatch)(withStyles(s)(BookingEngine));
